class DcbLineToggle extends HTMLElement {
  connectedCallback() {
    // The section script can run before this element's children are parsed,
    // which would leave every querySelector null and no listeners attached.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  init() {
    const scope = this.closest('.dcb-page')?.querySelector('[data-line-scope]');
    if (!scope) return;
    this.querySelectorAll('[data-line-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = btn.getAttribute('data-line-btn');
        this.querySelectorAll('[data-line-btn]').forEach((b) => b.classList.toggle('is-active', b === btn));
        scope.querySelectorAll('[data-line-pure]').forEach((el) => { el.hidden = line !== 'pure'; });
        scope.querySelectorAll('[data-line-studio]').forEach((el) => { el.hidden = line !== 'studio'; });
      });
    });
  }
}
customElements.define('dcb-line-toggle', DcbLineToggle);
